import packageModules from "@/api/packageModules";
import router from "@/router";
import { notify, notifyWarn } from "@/utils/notification-helper"
//import router from '@/router/index';

const state = {
    package: [],
    features: [],
    editModule: [],
    dataToAdd: []
}
const getters = {
    package: state => state.package,
    features: state => state.features,
    editModule: state => state.editModule 
}
const actions = {
    async getPackages({commit}){
        const response = await packageModules.packageList();
        commit('getModuleValue', response.data.result)
    },
    async getFetaureList({commit}){
        const response = await packageModules.getFetaure();        
        commit('getFeatureData', response.data.result)
    },
    async createNewModule({commit},payload){
        const reqRes = await packageModules.addModules(payload);
        if (reqRes.status == 200) {
            notify("Module created successfully!");
          } else {
            notifyWarn("Unable to create module!")
          }
        const response = await packageModules.packageList();
        commit('getModuleValue', response.data.result)        
    },
    async editModule({commit},userdata){
        const response = await packageModules.getPackageById(userdata.id);
        commit('editModule', response.data.result)
    },
    async deleteModule({commit},moduleID){
        const reqRes = await packageModules.removePackage(moduleID); 
        if (reqRes.status == 200) {
            notify("Module deleted successfully!");
          } else {
            notifyWarn("Unable to delete module!")
          }
        const response = await packageModules.getFetaure();        
        commit('getFeatureData', response.data.result)
    },
    async updateModule({commit},payload){
        var id =  payload.id;       
        var userData = {
            Name: payload.Name,
            features: payload.features
        };
        const reqRes = await packageModules.updateModule(id,userData);  
        if (reqRes.data?.status === true) {
            notify("Module updated successfully!")
          } else {
            notifyWarn("Unable to update module!")
          }      
        const response = await packageModules.packageList();
        commit('getModuleValue', response.data.result) 
    }    
    
}
const mutations = {
    getModuleValue(state,packageData){
        state.package = packageData
    },
    getFeatureData(state,feature){
        state.features = feature;
    },
    editModule(state,module){
        state.editModule = module;
        var id = state.editModule.id;
        router.push(
            {
                name: 'UpdateModule',
                path: "edit",
                params: { modId : id }
            }
        );
    }

}

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}